import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { isUserVerified } from '../../../utils/api_service/user_api';
import { FailureNotice } from './notices/failure_notice';
import { SuccessNotice } from './notices/success_notice';

type RequestStatus = 'Success' | 'Failed' | 'Pending';

export const ConfirmNotice = () => {
  const history = useHistory();
  const { token } = useParams<{token: string}>();
  const [status, setStatus] = useState<RequestStatus>('Pending');

  const navigateToSignIn = () => history.push('/login');

  useEffect(() => {
    isUserVerified(token)
      .then(response => {
        if (response.ok) {
          setStatus('Success');
        } else {
          setStatus('Failed');
        }
      })
      .catch(error => {
        if (error) {
          setStatus('Failed');
        }
      });
  }, [token]);

  const renderNotice = () => {
    if (status === 'Pending') {
      return (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', p: 4 }}>
          <CircularProgress size={48} color='primary' />
        </Box>
      );
    } else if (status === 'Success') {
      return <SuccessNotice navigateToSignIn={navigateToSignIn} />;
    } else {
      return <FailureNotice />;
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        width: '100%',
        bgcolor: 'background.default',
        p: 2,
      }}
    >
      {renderNotice()}
    </Box>
  );
};

